import { useEffect, useState } from "react"
import { Api } from "../../../helpers/Api";
import CardGrid from "../Components/CardGrid/CardGrid";
import LoadingSpinner from "../Components/Spinner/LoadingSpinner";
import HomePageHeader from "../Components/Header/HomePageHeader";
import HomePageFooter from "../Components/Footer/HomePageFooter";
import Moment from 'moment';
import dateFormat from '../../../helpers/DateFormate';

const config = {

    _poster: (object) => {
        return  object.poster ? <img src={object.poster} alt="cardimg" /> : <img src='../../../../images/cardimg.svg' alt="cardimg" />;
    },
    _0: (object) => {
        return object.length === 0 ? <h2 className="event-name">No <span style={{ color: 'red' }}>Events</span></h2> 
        : <h2 className="event-name">Upcoming <span style={{ color: 'red' }}>Events</span></h2>;
    },
    _1: (object) => {
        return <h4 className="card-title"> Registration Open | <span style={{ color: '#002147' }}> Event Fee</span> {object.fee ? object.fee : 'free'}</h4>;
    },
    _2: (object) => {
        return object?.last_registration.substr(8, 2);
    },
    _3: (object) => {
        return Moment(object?.last_registration.substr(0, 10)).format(dateFormat.HomePageDateFormat).substring(3);
    },
    _4: (object) => {
        return object.location == 'Offline' ? <img src='../../../../images/location-icon.svg' alt="offline" /> : <img src='../../../../images/online-icon.svg' alt="online" />
    },
    _5: (object) => {
        return object.location == 'Online' || !object.address_line_1 ? object.location : `${object.address_line_1}`;
    },
    _6: (object) => {
        return `${object.name}`;
    },
    _7: (object) => {
        // return `/registration/${object?.id}/new`;
    },
    _8: (object) => {
        return `Register Now`;
    },
    _9: (object) => {
        return `/EventDetail/${object?.id}`;
    },
    _10: (object) => {
        return `View Details`;
    },
}

const HomePage = () => {

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        setIsLoading(true);
        Api.call('/getEvent').then(response => {
            setData(response);
        })
            .catch(console.log)
            .finally(() => { setIsLoading(false) });
    }, []);

    return (
    <>
        {
            isLoading ? <LoadingSpinner /> : <>
            <HomePageHeader divDetails={true} BackgroundUrl={'../../../../images/background.png'} />
            <CardGrid config={config} data={data} /><HomePageFooter />
            </>
        }
    </>
    )
}
export default HomePage;
